import React, { useEffect } from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { useAppSearchParams } from '../../hooks/useAppSearchParams'

export enum TabKeys {
  COURSE_SECTIONS = 'Course Sections',
  STUDENT_ENROLLMENTS = 'Enrollments'
}

export const VIEW_PARAM_KEY = 'tab'

const TermsCourseSectionTab: React.FC = () => {
  const { searchParams, setUrlParams } = useAppSearchParams()
  const tab = searchParams.get(VIEW_PARAM_KEY) || TabKeys.COURSE_SECTIONS

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string): void => {
    setUrlParams({ tab: newValue })
  }

  useEffect(() => {
    setUrlParams({ tab })
  }, [tab])

  useEffect(() => {
    if (!searchParams.get(VIEW_PARAM_KEY)) {
      setUrlParams({ [VIEW_PARAM_KEY]: tab })
    }
  }, [searchParams, setUrlParams])

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 3, mb: 4 }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="Terms Tabs" >
        <Tab label={TabKeys.COURSE_SECTIONS} value={TabKeys.COURSE_SECTIONS} sx={{ fontWeight: 600 }} />
        <Tab label={TabKeys.STUDENT_ENROLLMENTS} value={TabKeys.STUDENT_ENROLLMENTS} sx={{ fontWeight: 600 }} />
      </Tabs>
    </Box>
  )
}

export default TermsCourseSectionTab
